import type {Values} from '@wix/devzai-utils-common';

/**
 * Visual design options for action buttons in row templates.
 * This setting controls how the primary action button appears in row-style list items.
 */
export const DoppeRowTemplateButtonDesign = {
    /**
     * Textual link style with an arrow icon suffix.
     * Shows the button text followed by a directional arrow.
     * Most subtle option that blends with the content.
     */
    Icon: 'icon',

    /**
     * Circular icon-only button with an arrow.
     * Compact visual that draws attention without text.
     */
    IconButton: 'iconButton',

    /**
     * Full text button with standard button styling.
     * Most prominent option that clearly indicates an action.
     */
    Button: 'button',

    /**
     * No button displayed.
     * The entire row is still clickable for navigation.
     */
    None: 'none',
} as const;

export type DoppeRowTemplateButtonDesign = Values<typeof DoppeRowTemplateButtonDesign>;
